// @flow
import AddRemoveItemsModalTemplate from './AddRemoveItemsModalTemplate';

export default AddRemoveItemsModalTemplate;
